import { render, staticRenderFns } from "./ImageComparisonSection.vue?vue&type=template&id=79bbb76c&scoped=true"
import script from "./ImageComparisonSection.vue?vue&type=script&lang=js"
export * from "./ImageComparisonSection.vue?vue&type=script&lang=js"
import style0 from "./ImageComparisonSection.vue?vue&type=style&index=0&id=79bbb76c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bbb76c",
  null
  
)

export default component.exports